import { useNavigate } from 'react-router-dom'
import { trackInternalEvent } from '@rio/tracking'
import { useEffect } from 'react'
import { useI18n } from 'builder/hooks/useI18n'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import {
  Container,
  Title,
  Content,
  Description,
  Subtitle,
  ItemsContainer,
  Item,
  ItemContainer,
  ButtonsContainer,
  PremiumButton,
  CancelSubcriptionText,
  Header,
  Items,
  ItemNumber,
  Video,
} from './styles'
import ResumeVideoDesktop from './assets/resume_desktop.webm'
import ResumeVideoMobile from './assets/resume_mobile.webm'

interface SubscriptionCancellationResumeDistributionDisabledProps {
  onContinueCancellation: () => void
}

const ITEMS = (t: (key: string) => string) => [
  {
    number: 1,
    text: t('builder.subscription_cancellation_v4.resume_distribution.disabled.items.one'),
  },
  {
    number: 2,
    text: t('builder.subscription_cancellation_v4.resume_distribution.disabled.items.two'),
  },
  {
    number: 3,
    text: t('builder.subscription_cancellation_v4.resume_distribution.disabled.items.three'),
  },
]

const ItemsComponent = ({ isMobile, t }: { isMobile: boolean; t: (key: string) => string }) => (
  <Items $isMobile={isMobile}>
    <Subtitle>
      {t('builder.subscription_cancellation_v4.resume_distribution.disabled.subtitle')}
    </Subtitle>
    <ItemsContainer>
      {ITEMS(t).map(item => (
        <ItemContainer key={item.number}>
          <ItemNumber>{item.number}</ItemNumber>
          <Item>{item.text}</Item>
        </ItemContainer>
      ))}
    </ItemsContainer>
  </Items>
)

export const SubscriptionCancellationResumeDistributionDisabled = ({
  onContinueCancellation,
}: SubscriptionCancellationResumeDistributionDisabledProps) => {
  const navigate = useNavigate()
  const { i18n } = useI18n()
  const { isTablet } = useMediaQueries()

  useEffect(() => {
    trackInternalEvent('see_rd_page', { type: 'not_active' })
  }, [])

  return (
    <Container>
      <Header>{i18n.t('builder.subscription_cancellation_v4.auto_apply.header')}</Header>
      <Content>
        <Description>
          <Title>
            {i18n.t('builder.subscription_cancellation_v4.resume_distribution.disabled.title')}
          </Title>
          <ItemsComponent isMobile={false} t={i18n.t} />
        </Description>
        <Video src={isTablet ? ResumeVideoMobile : ResumeVideoDesktop} muted autoPlay playsInline />
        <ItemsComponent isMobile t={i18n.t} />
      </Content>
      <ButtonsContainer>
        <PremiumButton
          onClick={() => {
            trackInternalEvent('promo_acceptance', { promo: 'RD', where: 'cancellation' })
            navigate('/resume-distribution')
          }}
        >
          {i18n.t('builder.subscription_cancellation_v4.resume_distribution.disabled.get_started')}
        </PremiumButton>
        <CancelSubcriptionText onClick={onContinueCancellation}>
          {i18n.t('builder.subscription_cancellation_v4.resume_distribution.disabled.skip')}
        </CancelSubcriptionText>
      </ButtonsContainer>
    </Container>
  )
}
